<template>
    <div class="student-form-container">
       <!-- 搜索和添加按钮组 -->
       <div class="input-button-group">
         <el-input placeholder="请输入班级名称" style="width: 200px;" v-model="$store.state.name"></el-input>
         <el-button @click="handleSearch" class="add-button" type="primary">搜索</el-button>
         <el-button type="primary" class="add-button" @click="dialogFormVisible(true)">添加</el-button>
         <el-button @click="deletedata" class="add-button" type="primary">删除</el-button>
       </div>
     </div>
   </template>
   
   <style scoped>
   .input-button-group {
       display: flex;
       align-items: center;
       margin-bottom: 20px;
   }
   
   
   .add-button {
       background-color: #ff69b4;
       /* 玫红色按钮背景 */
       color: white;
       border: none;
       margin-left: 10px;
       border-radius: 4px;
   }
   
   ::v-deep .add-button:hover {
    background-color: #ff1493 !important;
    color: white !important;
    border-color: #ff1493 !important;
}
   </style>
   <script>
   import store from '@/store';
   export default {
     data() {
       return {
         name: '',
       };
     },
     methods: {
      deletedata(){
        this.$confirm('确定删除该班级吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.state.delete=true;
        }).catch(() => {
           
        })},
       handleSearch() {
         let searchValue = this.$store.state.name || 'ALL';
        this.$store.commit('setname', searchValue); // 触发搜索时更新name
       },
       dialogFormVisible(visible) {
         store.commit('setDialogFormVisible', visible);
       },
     }
   
   }
   </script>

   <style scoped>

   ::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f5f5f5 !important;
  color: #333 !important;
  font-weight: 500 !important;
}

  </style>